import React from 'react';
import {Modal, Row} from 'antd';
import {connect} from 'react-redux'
import {changeSlideOwner} from '../../redux_actions/slides.action';

class RevokeSlideOwner extends React.Component {

    constructor(props) {
        super(props);
    }

    handleOk = () => {
        this.props.selectedRowKeys.forEach((value) => {
            this.props.dispatch(changeSlideOwner(this.props.allSlides[value], null));
        });
        this.handleCancel();
    }

    handleCancel = () => {
        this.props.closeModal();
    }

    render() {

        let getInfoMessage = (
            <div>
                <br/>
                <Row style={{marginLeft: 8}}>
                    <div>Owner of total <b>{this.props.selectedRowKeys.length}</b> slides will be removed.</div>
                    <div>Slides won't be visible to current owner.</div>
                </Row>
            </div>
        )

        return (
            <Modal
                title="Revoke Slide Access From Owner"
                visible={this.props.modalVisible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >
                <div>
                    {getInfoMessage}
                </div>
            </Modal>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        urlState: state.searchReducer,
        allSlides: state.slidesReducer,
        allGroups: state.searchUserReducer.groups,
    }
}

export default connect(mapStateToProps)(RevokeSlideOwner);
